import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";

const CountryListComponent = loadable(
  () => import("../../components/Country/CountryList")
);

const CountryList = () => {
  const { mutateAsync: patchUser } = usePatchHook({ queryKey: ["country"], navigateURL: null })

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value
    };
    const url = `${APIS.LOCATION}${id}/`;
    const formData = payload
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e)
    }
  }
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Country</span>
      </div>
      <CountryListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default CountryList;
